module.exports = __webpack_public_path__ + "static/media/socialPiper-post-desktop-en.b4c257fc.png";